import { jsx } from 'react/jsx-runtime';
import { Global } from '@emotion/react';

/*
  Reads the `colors` object from our theme and generates css variables which are added to the root
  of the app's style sheet.

  These variables can then be used in our theme without needing js to interpolate them into strings
  for things like box-shadow which cannot be broken down into their individual parts.

  We can also use them to enable `look` to set a colour which is then used by other theme parts
  without needing to implement nested variants such as the shadow themes in the example below.

  eg:

  export const buttons = {
    variants: {
      base: {
        ":focus": {
          boxShadow: `0 0 0 4px var(--colors-primary-20)`,
          outline: "none",
        },
      },
      look: {
        critical: {
          --colors-shadow: "var(--colors-critical-shadow)"
          backgroundColor: "critical.60",
          color: "white",
          borderColor: "critical.60",
        },
        primary: {
          --colors-shadow: "var(--colors-primary-shadow)"
          backgroundColor: "primary.100",
          color: "white",
          borderColor: "primary.100",
        },
      },
      size: {
        sm: {
          boxShadow: "0px 8px 16px 0px var(--colors-shadow) 0px 4px 8px 0px var(--colors-shadow)",
          height: "34px",
        },
        lg: {
          boxShadow: "0px 16px 32px 2px var(--colors-shadow) 0px 8px 16px 2px var(--colors-shadow)",
          height: "58px",
        },
      }
    },
  };

  The Theme colours:

    const colors = {
      text: "#000000",
      primary: {
        "100": "#0066CC",
        shadow: "rgba(0, 102, 204, 0.4)",
      },
    };

  The resulting CSS:

    ":root": {
      --colors-text: "#000000";
      --colors-primary-100: "#0066CC";
      --colors-primary-shadow: "rgba(0, 102, 204, 0.4)";
    }
*/
var CSSVars = function (_a) {
    var theme = _a.theme;
    var colors = theme.colors, zIndices = theme.zIndices;
    var css = {};
    // colors
    for (var key in colors) {
        if (Object.prototype.hasOwnProperty.call(colors, key)) {
            var keyValue = colors[key];
            if (typeof keyValue === "string") {
                css["--colors-".concat(key)] = keyValue;
            }
            else if (typeof keyValue === "object") {
                for (var level in keyValue) {
                    if (Object.prototype.hasOwnProperty.call(keyValue, level)) {
                        var levelValue = keyValue[level];
                        if (typeof levelValue === "string") {
                            css["--colors-".concat(key, "-").concat(level)] = levelValue;
                        }
                    }
                }
            }
        }
    }
    // zIndices
    for (var key in zIndices) {
        if (Object.prototype.hasOwnProperty.call(zIndices, key)) {
            var keyValue = zIndices[key];
            css["--z-index-".concat(key)] = keyValue;
        }
    }
    return (jsx(Global, { styles: {
            ":root": css,
            "html, body": {
                margin: 0,
                color: theme.colors["text-main"],
            },
        } }));
};

export { CSSVars };
//# sourceMappingURL=CSSVars.js.map
